// Title <= 10 words
// Img: 1.5 Aspect Ratio

import metadata from './metadata';

const projectList = [
  {
    title:
      'Wonton Warrior is a young noodle house specialising in handmade wontons and noodles.',
    img: 'wonton-warrior.jpg',
    url: 'https://wontonwarrior.com.au',
  },
  {
    title: 'My Recursive Personal Portfolio.',
    img: 'my-website.jpg',
    url: metadata.url,
  },
];

export default projectList;
